import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import classNames from "classnames"
import useDimensions from "react-use-dimensions"
import resourcePdf1 from "~/images/resources/CIW_Part1.pdf"
import resourcePdf2 from "~/images/resources/CIW_Part2.pdf"
import resourcePdf3 from "~/images/resources/CIW_Part3.pdf"
import resourcePdf4 from "~/images/resources/CIW_Part4.pdf"
import resourcePdf5 from "~/images/resources/CIW_Part5.pdf"
import ReactGA from "react-ga"

const ResourcesSection = () => {
  const data = useStaticQuery(graphql`
    query {
      img1: file(name: { eq: "CIW_Part1img" }) {
        childImageSharp {
          fluid(maxHeight: 160) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      img2: file(name: { eq: "CIW_Part2img" }) {
        childImageSharp {
          fluid(maxHeight: 160) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      img3: file(name: { eq: "CIW_Part3img" }) {
        childImageSharp {
          fluid(maxHeight: 160) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      img4: file(name: { eq: "CIW_Part4img" }) {
        childImageSharp {
          fluid(maxHeight: 160) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      img5: file(name: { eq: "CIW_Part5img" }) {
        childImageSharp {
          fluid(maxHeight: 160) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)
  const [ref, { x, height, width }] = useDimensions()
  console.log("Height, resources, ", height)
  const { img1, img2, img3, img4, img5 } = data

  const logDownload = (label) => {
    ReactGA.event({
      category: "filed",
      action: "download",
      label: label,
    })
  }

  const resources = [
    {
      resource: resourcePdf1,
      subtitle:
        "These four resources encourage young people to think critically about online environments and to elevate youth voice on the topic of Digital Rights and Responsibilities.",
      title: "Digital Rights and Responsibilities: Report",
      img: img1,
      label: "CIW_Part1.pdf"
    },
    {
      ref: ref,
      resource: resourcePdf2,
      subtitle:
        "How do youth view their digital rights and responsibilities? This report lays out findings from Chicago Ideas Youth Kick Off, where 250 young people discussed this emerging issue.",
      title: "Digital Rights and Responsibilities: Resource Packet",
      img: img2,
      label: "CIW_Part2.pdf"
    },
    {
      resource: resourcePdf3,
      subtitle:
        "These three sessions help young people learn more about how digital spaces are created—and how they can change those spaces for the better.",
      title: (
        <span>
          Digital Accountability:
          <br />
          Resource Packet
        </span>
      ),
      img: img3,
      label: "CIW_Part3.pdf"
    },
    {
      resource: resourcePdf4,
      subtitle:
        "These three resources support youth in pinpointing the biggest challenges they see in digital life—and developing an actionable set of guidelines to address them.",
      title: "Digital Ethics and Practices: Resource Packet",
      img: img4,
      label: "CIW_Part4.pdf"
    },
    {
      resource: resourcePdf5,
      subtitle:
        "This one-page guide offers a set of principles that promote more positive online experiences.",
      title: "Principles of Digital Community: Infographic",
      img: img5,
      label: "CIW_Part5.pdf"
    },
  ]
  return (
    <section className="flex flex-col justify-center bg-night text-white leading-normal px-content-mobile md:px-content pt-8 pb-16">
      <h2 className="font-heading uppercase text-center text-3xl mx-auto">
        Resources
      </h2>
      <p className="mx-auto max-w-about pt-4 pb-4 text-center self-center">
        Want to educate your peers about healthy online life? Use these
        resources to inform and empower your community.
      </p>

      <div className="flex flex-col md:flex-row flex-wrap -mx-2 justify-center">
        {resources.map((resource, index) => (
          <div
            className={classNames("w-full md:w-1/2 lg:w-1/3 p-4")}
            key={index}
          >
            <a
              className="p-4 flex border border-yellow h-full"
              href={resource.resource}
              onClick={() => logDownload(resource.label)}
              target="_blank"
              ref={resource.ref}
              style={{
                height: `${resource.ref ? "initial" : height + "px"}`,
                boxSizing: "border-box",
              }}
            >
              <div style={{ width: "160px", minWidth: "160px" }}>
                <Img
                  fluid={resource.img.childImageSharp.fluid}
                  alt="Resource"
                  loading={"eager"}
                />
              </div>
              <div className="flex flex-col ml-2 w-full">
                <h3 className="text-base md:text-lg">{resource.title}</h3>
                <div className="mt-1 mb-1 h-1 w-24 bg-yellow"></div>
                <div className="w-full block mt-2">
                  <p className="text-gray text-sm">{resource.subtitle}</p>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </section>
  )
}

export default ResourcesSection
